import { render, staticRenderFns } from "./DeptRecord.vue?vue&type=template&id=62b07cc1&scoped=true&"
import script from "./DeptRecord.vue?vue&type=script&lang=js&"
export * from "./DeptRecord.vue?vue&type=script&lang=js&"
import style0 from "./DeptRecord.vue?vue&type=style&index=0&id=62b07cc1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b07cc1",
  null
  
)

export default component.exports